import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Disable browser's automatic scroll restoration (critical for PWA/mobile).
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Whenever the pathname changes, scroll the window to the top.
// Preserves scroll when the URL only changes via hash (e.g. anchor links).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let the browser handle anchor jumps
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
